import React, { useEffect, useState, useCallback } from "react";
import { ITournament, ITournamentApplication } from "@/redux/tournaments/types";
import { useAppDispatch } from "@/redux/store";
import {
  fetchGetTournamentApplications,
} from "@/redux/tournaments";
import { TournamentApplicationsContent } from "@/pages/Tournaments/modals/TournamentApplicationsModal/components/TournamentApplicationsContent/TournamentApplicationsContent";
import styles from "./ManageTournamentContent.module.scss";

interface ManageTournamentContentProps {
  tournament: ITournament;
}

export const ManageTournamentContent: React.FC<ManageTournamentContentProps> = ({
  tournament,
}) => {
  const dispatch = useAppDispatch();
  const [applications, setApplications] = useState<ITournamentApplication[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadApplications = useCallback(async () => {
    if (!tournament?.id) {
      console.warn("[ManageTournamentContent] Tournament ID is missing");
      setIsLoading(false);
      return;
    }
    
    try {
      setIsLoading(true);
      console.log("[ManageTournamentContent] Loading applications for tournament:", tournament.id);
      const response = await dispatch(
        fetchGetTournamentApplications(tournament.id)
      ).unwrap();
      console.log("[ManageTournamentContent] Applications loaded:", response.applications?.length || 0, "applications");
      setApplications(response.applications || []);
    } catch (error) {
      console.error("[ManageTournamentContent] Error loading tournament applications:", error);
      setApplications([]);
    } finally {
      setIsLoading(false);
    }
  }, [tournament?.id, dispatch]);

  useEffect(() => {
    console.log("[ManageTournamentContent] Component mounted/updated, tournament:", tournament?.id);
    loadApplications();
  }, [loadApplications]);

  const handleApplicationsChange = (updatedApplications: ITournamentApplication[]) => {
    setApplications(updatedApplications);
  };

  console.log("[ManageTournamentContent] Render:", { 
    isLoading, 
    applicationsCount: applications.length, 
    tournamentId: tournament?.id,
    applications: applications
  });

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <p>Загрузка заявок...</p>
      </div>
    );
  }

  if (!applications || applications.length === 0) {
    return (
      <div className={styles.loading}>
        <p>Заявок пока нет</p>
      </div>
    );
  }

  console.log("[ManageTournamentContent] Rendering TournamentApplicationsContent with:", {
    applicationsCount: applications.length,
    tournamentId: tournament.id,
    firstApplication: applications[0]
  });

  return (
    <div className={styles.container}>
      <TournamentApplicationsContent
        applications={applications}
        tournamentId={tournament.id}
        onApplicationsChange={handleApplicationsChange}
      />
    </div>
  );
};
